<template>
  <main class="terms">
    <ContentsHeader />
    <article class="main_content">
      <div class="pankuzu">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a :href="topurl()">トップ</a></li>
          <li class="breadcrumb-item active">利用規約</li>
        </ol>
      </div>

      <div class="terms_list__wrapper">
        <section class="top_link_list">

          <h1 class="page-title">FitGap利用規約</h1>
          <div class="page-body">
            <p id="c6534332-e0be-4cb2-9d1f-f533a6a9b7ff" class="">
              当社が定める「FitGap利用規約」（以下、「本規約」という。）は、株式会社PIGNUS（以下、「当社」という。）が提供するサービス「FitGap」（以下、「本サービス」という。）の利用に関する条件を定めるものです。
            </p>
            <h2 id="b14eae6f-3c29-4bf5-9306-72b2b306af94" class="">1. 本規約への同意</h2>
            <p id="25897c43-ce16-4fd9-8de5-3e76fe10e412" class="">
              本サービスをご利用いただく方（以下、「利用者」という。）は、本規約に同意しない限り本サービスを利用することはできません。</p>
            <h2 id="56f52647-2b1d-4928-976f-0c7696292ad3" class="">2. 本規約の改定・変更・通知</h2>
            <ol type="1" id="35e6d882-7568-4dc5-889e-363afe5a0f0e" class="numbered-list" start="1">
              <li>当社は、利用者の事前の個別承諾を得ることなく、民法548条の4の規定に基づき、本規約を変更又は追加できるものとします。</li>
            </ol>
            <ol type="1" id="5c3b6648-81d7-4a4a-82a0-f2c1f78186e7" class="numbered-list" start="2">
              <li>前項の変更を行う場合、当社は、その効力発生日を定め、利用者に対して、当該効力発生日の2週間前までに本サービスへの掲示など当社が合理的に相当と判断する方法により、以下の事項を通知するものとします。1.
                本規約を変更する旨</li>
            </ol>
            <ol type="1" id="ad57fabc-56f9-474b-9ec4-de9f4a7a4f05" class="numbered-list" start="3">
              <li>変更後の本規約の内容</li>
            </ol>
            <ol type="1" id="8587d86d-bb3d-455e-af0c-a5844a54a7ba" class="numbered-list" start="4">
              <li>効力発生日</li>
            </ol>
            <h2 id="5d8ca5ca-534d-499b-a93f-5936f68df0fa" class="">3. 知的財産権</h2>
            <ol type="1" id="cfb2ed16-c368-4072-b9fc-9b6e776b9b27" class="numbered-list" start="1">
              <li>
                本サービスを構成する全てのプログラム、ソフトウェア及びこれらに付随する技術全般に関する知的財産権及びその他の権利、ならびに本サービスを通じて提供される情報に関する著作権その他の権利は、特段の表示がない限り、当社に帰属します。
              </li>
            </ol>
            <ol type="1" id="613bc118-54fb-4b0c-8d6d-e6738bf4af04" class="numbered-list" start="2">
              <li>
                利用者は、本サービスを利用することにより得られる一切の情報を、当社の事前かつ明示の許諾なく、複製、出版、放送、公衆送信を行ってはならず、その他方法を問わず、自己のための利用の範囲を越えて利用してはならないものとします。
              </li>
            </ol>
            <h2 id="27c7ba4e-96ea-4b13-b8bc-7522debd6974" class="">4. 禁止事項</h2>
            <p id="a62cde0c-d854-4664-a88a-d27dd2b25c3a" class="">
              利用者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはなりません。</p>
            <ol type="1" id="e66cb416-0c48-44ec-bfd8-24b9666740a6" class="numbered-list" start="1">
              <li>法令、裁判所の確定した判決、決定もしくは命令、又は法令上拘束力のある行政措置に違反する行為</li>
            </ol>
            <ol type="1" id="07c60b2f-b6d7-4929-8e55-a9fe9a5f8c70" class="numbered-list" start="2">
              <li>当社、本サービスの他の利用者又はその他の第三者に対する詐欺又は強迫行為</li>
            </ol>
            <ol type="1" id="a8217d9b-d791-48ea-821c-413017dcf0af" class="numbered-list" start="3">
              <li>公序良俗に反する行為</li>
            </ol>
            <ol type="1" id="7d3e9d25-1937-4d2d-a913-7f281301b9bb" class="numbered-list" start="4">
              <li>当社、本サービスの他の利用者又はその他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利又は利益を侵害する行為</li>
            </ol>
            <ol type="1" id="7a220c85-85da-4335-80da-179573775c0c" class="numbered-list" start="5">
              <li>本サービスを通じ、以下に該当し、又は該当すると当社が判断する情報を送信、アップロード等する行為- コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報</li>
            </ol>
            <ul id="6b9311b6-18cc-4897-b67b-d6a35b198fd7" class="bulleted-list">
              <li style="list-style-type:disc">当社、本サービスの他の利用者又はその他の第三者の名誉又は信用を毀損する表現を含む情報</li>
            </ul>
            <ul id="91050fc4-6e1d-40fd-aa11-b44e94e12796" class="bulleted-list">
              <li style="list-style-type:disc">反社会的な表現や他人に不快感を与える表現を含む情報</li>
            </ul>
            <ul id="837f3de6-6443-485f-93bd-55c3c366e34c" class="bulleted-list">
              <li style="list-style-type:disc">チェーンメール等の第三者への情報の拡散を求める情報</li>
            </ul>
            <ol type="1" id="cc61dea8-e078-4aa6-ae80-e3269eb9c1a8" class="numbered-list" start="1">
              <li>本サービスのネットワーク又はシステム等に過度な負担を欠ける行為</li>
            </ol>
            <ol type="1" id="1b72a2d5-7d2d-4106-8445-689efb4e8afa" class="numbered-list" start="2">
              <li>本サービスの運営を妨害するおそれのある行為</li>
            </ol>
            <ol type="1" id="9862636b-e213-4e7a-bf52-4b1cdf968db6" class="numbered-list" start="3">
              <li>当社のネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為</li>
            </ol>
            <ol type="1" id="6653f8e3-91a3-4bb9-bc87-b087175845c8" class="numbered-list" start="4">
              <li>本サービスに関するプログラム等の改変、リバースエンジニアリング、解析またはユーティリティの作成・頒布等の行為</li>
            </ol>
            <ol type="1" id="72910a3b-db05-4023-8a4d-a0325bbb76b2" class="numbered-list" start="5">
              <li>当社、本サービスの他の利用者又はその他の第三者に不利益、損害、不快感を与える行為</li>
            </ol>
            <ol type="1" id="e7925cb4-7063-4efc-afdd-d8160baef509" class="numbered-list" start="6">
              <li>本規約の定めにに抵触する行為</li>
            </ol>
            <ol type="1" id="0d4e9502-3971-4acf-87c7-4a1335bc6361" class="numbered-list" start="7">
              <li>反社会勢力への利益供与</li>
            </ol>
            <ol type="1" id="83edbcdb-b41a-421a-8e0c-328604cdab97" class="numbered-list" start="8">
              <li>宗教活動又は宗教団体への勧誘行為</li>
            </ol>
            <ol type="1" id="38b4dcf7-a937-4d6d-a6d5-0bcff0a09dae" class="numbered-list" start="9">
              <li>前各号の行為を直接又は間接に惹起し、又は容易にする行為</li>
            </ol>
            <ol type="1" id="8e60dfb1-911b-43eb-9b4f-e936dccb493c" class="numbered-list" start="10">
              <li>その他、当社が合理的に不適切と判断する行為</li>
            </ol>
            <h2 id="1de28d42-efff-4fa2-8667-26dfffe1d35a" class="">5. 免責</h2>
            <ol type="1" id="ad03b260-1fc6-46db-8158-6090c8102505" class="numbered-list" start="1">
              <li>
                本規約における当社の責任は合理的な努力をもって本サービスを運営することに限られ、当社は本サービスの正確性、完全性、有用性、信頼性、利用者への適合性等を保証するものではありません。本サービスの利用は、原則として利用者自身の判断と責任において行っていただきます。
              </li>
            </ol>
            <ol type="1" id="bc67e55d-ac6b-4c3f-8e0b-7623c7809bd6" class="numbered-list" start="2">
              <li>当社は、本サービスに関して合理的なセキュリティ措置を講じていますが、当社サービスへの不正アクセス又は当社サービスの不正利用を完全に防止することを保証するものではありません。</li>
            </ol>
            <ol type="1" id="8e9bf1ac-e0a3-48de-a304-3f289ceb5361" class="numbered-list" start="3">
              <li>当社は本サービスの運営上、業務の一部を再委託する場合があります。また当該再委託先の責めに帰する事由により生じた損害については、当社に帰責事由がある場合を除き、利用者に対して賠償する責任を負わないものとします。
              </li>
            </ol>
            <ol type="1" id="e033362f-81a4-409d-9d23-63cf1f69f631" class="numbered-list" start="4">
              <li>当社は、利用者間または利用者と第三者との間で生じた紛争等について、当社に帰責事由がある場合を除き、利用者に対して賠償する責任を負わないものとします。</li>
            </ol>
            <ol type="1" id="d09610f5-b8b0-40a2-bd6b-324b6ba9381d" class="numbered-list" start="5">
              <li>
                当社が利用者等に対し損害賠償責任を負う場合であっても、当社に故意又は重大な過失がある場合を除いて、当社は利用者等が直接かつ現実に被った損害を上限として損害賠償責任を負うものとし、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。
              </li>
            </ol>
            <h2 id="38310012-7d36-422a-b063-212258b11f87" class="">6. サービスの中止・廃止</h2>
            <ol type="1" id="2dbcbcb6-3a17-4018-8f0f-3e81014f134b" class="numbered-list" start="1">
              <li>当社は、以下のいずれかに該当する場合、利用者に通知することなく、本サービスの全部又は一部の提供を一次的に中止することができるものとします。1.
                本サービスの提供にあたり必要なシステム・設備等の点検・保守・工事等が必要となった場合</li>
            </ol>
            <ol type="1" id="7cfdcdea-2750-4160-8379-df919fe80dff" class="numbered-list" start="2">
              <li>火災、事故、停電、天災、戦争、テロ、暴動、騒乱、労働争議その他の緊急の事態の発生により、本サービスの提供が困難になった場合</li>
            </ol>
            <ol type="1" id="44b18d1e-4eb4-4244-88b7-1727c38845d6" class="numbered-list" start="3">
              <li>法令、行政処分等により、本サービスの提供が困難になった場合</li>
            </ol>
            <ol type="1" id="91bcb210-ece5-49f1-9626-65feb1307c4f" class="numbered-list" start="4">
              <li>その他、当社が本サービスの提供の一時中止が必要であると合理的に判断した場合</li>
            </ol>
            <ol type="1" id="89eaadc8-3aa0-48dc-ac9f-a9a57cef92bb" class="numbered-list" start="5">
              <li>
                当社は、本サービスの継続的な提供が困難だと判断した場合、当社の運営上本サービスの廃止が必要であると判断した場合、その他やむを得ない事由が発生した場合、利用者に対して、1週間前までに本サービスへの掲示など当社が合理的に相当と判断する方法により周知の上、本サービスの提供を廃止することができるものとします。但し、やむを得ない事情がある場合、利用者への事前の周知を行うことなく、本サービスの提供を廃止することがあります。
              </li>
            </ol>
            <h2 id="547df3ec-a9fd-4697-bc21-6d9d516455e9" class="">7. 解除</h2>
            <p id="bf4eb5ce-4838-4233-87a3-793392f884e6" class="">
              利用者が以下の各号の一に該当する場合、当社は利用者に対する通知催告を要することなく、本サービスに係る契約を解除することができるものとします。</p>
            <ol type="1" id="7c938b3f-f944-45b9-8448-356259f9b75b" class="numbered-list" start="1">
              <li>利用者が、本規約4.の禁止事項のいずれかに違反した場合</li>
            </ol>
            <ol type="1" id="bf83b92d-1c6e-4cf4-b083-aa373b98c2ff" class="numbered-list" start="2">
              <li>本サービスに関する利用者の行為が法令又は公序良俗に違反するおそれがある場合</li>
            </ol>
            <ol type="1" id="97d917be-10d7-41af-a86f-710c7cbf5c85" class="numbered-list" start="3">
              <li>利用者が本規約9条に定める反社会的勢力等であることが判明した場合</li>
            </ol>
            <h2 id="d7931048-9748-4635-9de0-c50141676ba9" class="">8. 個人情報の取扱い</h2>
            <p id="6cb5e27d-284d-443f-ab68-c3de866c9932" class="">当社は、本サービスに関連して取得した個人情報を、当社の定めるプライバシーポリシーに従って適切に取り扱います。
            </p>
            <h2 id="2784b088-735b-4085-be8e-4afbadf5db9e" class="">9. 反社会的勢力の排除</h2>
            <ol type="1" id="42518f7a-5e78-4779-8d33-2750e77b0813" class="numbered-list" start="1">
              <li>
                利用者は、自身が暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずるもの（以下｢暴力団員等｣という。）に該当せず、かつ、暴力団員等と関与していないことを表明し、将来にわたっても所属若しくは該当、又は関与しないことを確約するものとします。
              </li>
            </ol>
            <ol type="1" id="8a010327-f5a4-4df9-aa9b-cd5ff29cb91a" class="numbered-list" start="2">
              <li>
                当社は、利用者が暴力団員等に所属若しくは該当する、又は正当な理由なく関与していると判断した場合、当該利用者に事前に通知等を行うことなく、当該利用者の本サービスサイトへのアクセスを禁止する等の適切な措置を講じることがあります。
              </li>
            </ol>
            <ol type="1" id="e9230601-5811-436b-87b8-1926c5a25b97" class="numbered-list" start="3">
              <li>当社は前項の措置による利用者の損害を賠償する責任を一切負わないものとします。</li>
            </ol>
            <h2 id="9dcb5464-a434-4437-a7dd-7ac37f13dffa" class="">10. 譲渡禁止</h2>
            <p id="7609b411-188a-4b90-97b1-e2f9dc12cdce" class="">
              利用者は、当社の書面による事前の承諾がない限り、本サービスに係る契約上の地位を移転し、又は、本サービスに係る契約に基づく権利義務を第三者に譲渡し、もしくは第三者の担保に供してはならないものとします。</p>
            <h2 id="98e75d96-24cc-4b7d-98ad-58228e5085f6" class="">11. 準拠法及び合意管轄</h2>
            <p id="459e3784-26b9-4ebc-8980-68e1a913a77b" class="">
              本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
            <h3 id="af330e15-5cd0-417c-847b-b943d1fba30d" class="">附則</h3>
            <p id="8d8489bc-d07d-48c6-8b42-ed14162eea39" class="">2021年03月 制定・施行</p>
            <p id="d27339bb-a84a-454a-a237-e247cdef8dab" class="">以上</p>
          </div>

        </section>
      </div>
      <div class="border_divider"></div>
    </article>
    <div style="margin-bottom: 32px" v-if="pager.isDebug">
      <div>デバグ</div>
    </div>
    <ContentsFooter :pager="pager" />
  </main>
</template>

<style>
.terms_list__wrapper .page-body h2 {
  margin-top: 24px;
}

.terms_list__wrapper .page-body h3 {
  margin-top: 16px;
}

.terms_list__wrapper .page-body p {
  padding-top: 8px;
}

.terms_list__wrapper .page-title {
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.75em;
}

.terms_list__wrapper h1 {
  font-size: 1.875rem;
  margin-top: 1.875rem;
}
</style>

<style scoped>
.terms {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
  background: #F9FBFB;
}

.main_content {
  flex: 1;
}

.terms_list__wrapper {
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.24);
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 8px;
  padding-right: 8px;
}

.terms_maintitle {
  color: #444545;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 16px;
}

.terms_list__date {
  color: #636464;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 4px;
}

.terms_list__description {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 16px;
}

.terms_list_session {
  border-top: 1px solid #EFF0F0;
  padding-top: 12px;
  padding-bottom: 8px;
}

.terms_list_session__header {
  color: #444545;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 8px;
}

.terms_list_session__body {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  margin-bottom: 8px;
}

.terms_list_session__li ol {
  padding-inline-start: 16px;
}
</style>


<script>
// @ is an alias to /src

// eslint-disable-next-line
import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { TermsPage } from "@/js/page/TermsPage.js";

export default {
  name: "TermsView",
  data() {
    return {
      page: new TermsPage(),
      isNetworking: false,
      title: "",
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.pager.changePage(this.page);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 " + this.title;
  },
  beforeUnmount() {
    //
  },
  methods: {
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    gotoFreeword() {
      this.$router.push({ name: "freeword" });
    },
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
